import { kataviAccommodation } from '../data/kataviAccommodation.js';

export const DEFAULT_ACCOMMODATION_SETTINGS = {
  page_intro:
    'We have partnered with several hotels in the Katavi region to provide comfortable accommodation options for conference attendees. Book early to secure your preferred hotel and take advantage of special conference rates.',
  booking_note:
    'Please mention "TDA Conference 2026" when making your reservation to receive special rates and ensure availability.',
  hotels: kataviAccommodation,
  transportation: {
    airport:
      'Most hotels offer shuttle services from Mpanda Airport. Please coordinate with your chosen hotel for airport transfers.',
    venue:
      'Several hotels provide shuttle services to the conference venue. Check with your hotel for schedules.',
    taxis:
      'Taxis are readily available throughout the region. Average cost from hotels to venue: TZS 5,000 - 15,000 depending on distance.',
  },
};
